module.exports = __webpack_public_path__ + "media/voice-start.9bac7757.mp3";